import { ICurbsideNotification, ICurbsideNotificationValidation } from '../types';
import { defaulLangTextValidation, defaultTTranslate, ShortCode } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export const curbsideNotificationSettingShortCodePickerOptions = (): IPickerOption[] => {
  return [{ value: ShortCode.CLIENT_NAME, label: localeStore.t('client_name') }];
};

export const defaultCurbsideNotification: ICurbsideNotification = {
  subject: defaultTTranslate,
  message: defaultTTranslate,
};

export const defaultCurbsideNotificationValidation: ICurbsideNotificationValidation = {
  isValid: true,
  subject: defaulLangTextValidation,
  message: defaulLangTextValidation,
};
